import { useLingui } from '@lingui/react/macro';

import { DesktopEntityFilter } from '@/components/SharedFilters/EntityFilter/DesktopEntityFilter';
import IconAssociate from '@/icons/Associate.svg';

import { useFilters } from '../FiltersState';

export const FiltersEntityOrGroup = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    entityOrGroupSelections: { entityOrGroupSelections, setEntityOrGroupSelections },
  } = useFilters();

  const selectedCount = entityOrGroupSelections.length;

  return (
    <DesktopEntityFilter
      selectedEntities={entityOrGroupSelections}
      setSelectedEntities={setEntityOrGroupSelections}
      tag={tag}
      label={t({
        id: 'settings.organization.entities.agreements.filters.entity.label',
        message: 'Entity',
      })}
      searchPlaceholder={t({
        id: 'settings.organization.entities.agreements.filters.entity.search',
        message: 'Search entities and groups',
      })}
      icon={<IconAssociate />}
      tagSelectedCountLabel={i18n._({
        id: 'settings.organization.entities.agreements.filters.entity.multiple',
        message: '{selectedCount} selected',
        values: { selectedCount },
      })}
    />
  );
};
